import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = {
  key: 0,
  class: "border-b border-gray-200 pt-4"
}
const _hoisted_3 = { class: "pt-6 mk-body-strong text-gray-900" }

import { BaseCard } from '@/lib/components/Card';
import { SubmissionAnswers } from '@/lib/components/SubmissionAnswers';
import { useI18n } from 'vue-i18n';
import { ref, computed } from 'vue';
import { ONBOARDING_QUESTIONS } from '@/lib/components/Programs/IbdProgram/constants';
import { EpisodeEncounter, QuestionnaireGroup } from '@/models';
import TouchpointSubHeader from './TouchpointSubHeader.vue';
import TouchpointHeader from './TouchpointHeader.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'SubmissionTouchpoint',
  props: {
    id: {},
    pathwayName: {},
    status: {},
    start: {},
    questionnaireResponses: {}
  },
  setup(__props: any) {

const props =
  __props;

const { t, d } = useI18n();

const mapQuestionnaires = (
  questionnaireResponses: EpisodeEncounter['questionnaire_responses']
): QuestionnaireGroup[] => {
  const questionnaires: QuestionnaireGroup[] = [];
  const groupQAByCategory = questionnaireResponses.reduce(
    (group, questionnaire) => {
      const { response_item } = questionnaire;
      group[response_item.group] = group[response_item.group] ?? [];
      group[response_item.group].push({
        question: response_item.question,
        answer: response_item.answer
      });
      return group;
    },
    {}
  );

  for (const category in groupQAByCategory) {
    if (category && category.toLowerCase() !== ONBOARDING_QUESTIONS) {
      questionnaires.push({
        title: category,
        questions: groupQAByCategory[category]
      });
    }
  }
  return questionnaires;
};
const questionnaires = ref(mapQuestionnaires(props.questionnaireResponses));

const headerItems = computed(() => [
  {
    label: t('custom.uhb.pathways.submitted-date'),
    value: d(props.start, 'shortMonth')
  }
]);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    id: _ctx.id,
    class: "pt-2"
  }, [
    _createVNode(_unref(BaseCard), {
      padding: "2",
      class: "px-0 py-4"
    }, {
      default: _withCtx(() => [
        _createVNode(TouchpointHeader, {
          title: _ctx.$t('custom.uhb.pathways.submission'),
          pathway: _ctx.pathwayName,
          status: _ctx.status?.name
        }, null, 8, ["title", "pathway", "status"]),
        _createVNode(TouchpointSubHeader, {
          items: headerItems.value,
          class: "px-5"
        }, null, 8, ["items"]),
        (questionnaires.value.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(questionnaires.value, ({ title, questions }, key) => {
          return (_openBlock(), _createElementBlock("dl", {
            key: key,
            class: "px-5 flex flex-auto flex-wrap gap-x-2 leading-5"
          }, [
            _createElementVNode("dt", _hoisted_3, _toDisplayString(title), 1),
            _createVNode(_unref(SubmissionAnswers), { items: questions }, null, 8, ["items"])
          ]))
        }), 128))
      ]),
      _: 1
    })
  ], 8, _hoisted_1))
}
}

})